import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { OrderDetail } from "@/components/admin/OrderDetail";

export const Route = createFileRoute("/_authenticated/admin/orders/$id")({
  head: () => ({
    meta: [
      { title: "Админ — Поръчка | FIXHEN" },
      { name: "description", content: "Детайли на поръчка, доставка и товарителница с CN22 в FIXHEN." },
      { property: "og:title", content: "Поръчка и доставка | FIXHEN" },
      { property: "og:description", content: "Управление на поръчка и товарителница с митническа декларация CN22." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: RouteComp,
});

function RouteComp() {
  const { id } = Route.useParams();
  return (
    <AdminLayout>
      <OrderDetail id={id} />
    </AdminLayout>
  );
}